module.exports = __webpack_public_path__ + "posture/static/img/sideBone.4bd2ac1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posture/bone/sideBone.png
// module id = Ocay
// module chunks = 1